// extracted by mini-css-extract-plugin
export default {"hourglass":"preloader_hourglass__KNCLF","flip":"preloader_flip__uOOZH","fill":"preloader_fill__qYJf4","glare":"preloader_glare__3As4d"};